import React from 'react';
import config from '../../config';

export default function WelcomePage() {
  return (
    <div style={styles.page}>
      {/* Opera Cloud-style teal header */}
      <div style={styles.header}>
        <img
          src={config.logoUrl}
          alt="Hard Rock"
          style={styles.headerLogo}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <span style={styles.headerTitle}>Opera SideCar</span>
      </div>

      {/* Centered content */}
      <div style={styles.body}>
        <div style={styles.card}>
          <div style={styles.iconRing}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
              stroke="rgb(17,129,151)" strokeWidth="1.8"
              strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <h1 style={styles.heading}>Welcome to Unity Link</h1>
          <p style={styles.sub}>Opera SideCar</p>
          <div style={styles.divider} />
          <p style={styles.hint}>
            Open a member profile in Opera Cloud to get started.
          </p>
        </div>
      </div>
    </div>
  );
}

const TEAL = 'rgb(17, 129, 151)';

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#f5f5f5',
    fontFamily: "'Segoe UI', 'Roboto', Arial, sans-serif",
    margin: 0,
  },
  header: {
    background: TEAL,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    gap: 10,
    flexShrink: 0,
  },
  headerLogo: {
    height: 22,
    objectFit: 'contain',
    filter: 'brightness(0) invert(1)',  // white logo on teal
  },
  headerTitle: {
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  body: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 8,
    maxWidth: 280,
  },
  iconRing: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    border: `2px solid ${TEAL}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
    background: '#fff',
  },
  heading: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600,
    color: '#1a2e44',
    lineHeight: 1.3,
  },
  sub: {
    margin: 0,
    fontSize: 13,
    fontWeight: 500,
    color: TEAL,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  divider: {
    width: 40,
    height: 2,
    background: TEAL,
    borderRadius: 2,
    margin: '6px 0',
    opacity: 0.4,
  },
  hint: {
    margin: 0,
    fontSize: 12,
    color: '#6b7b8d',
    lineHeight: 1.5,
    maxWidth: 220,
  },
};
